import type { SearchExtensionTouchpoint } from './types';
import { readonly, writable } from 'svelte/store';
import { SEARCH_EXTENSION_MAX_TOUCHPOINT_ACTIVE_DURATION } from './constants';

const store = writable<SearchExtensionTouchpoint | undefined>(undefined);
const { set } = store;

/**
 * This function is used to temporarily store that a search extension touchpoint has been activated.
 */
async function activate(touchpointName: SearchExtensionTouchpoint) {
	set(touchpointName);
	setTimeout(() => {
		set(undefined);
	}, SEARCH_EXTENSION_MAX_TOUCHPOINT_ACTIVE_DURATION);
}

export const searchExtensionTouchpoint = {
	...readonly(store),
	activate,
};
